<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Condiciones de Renovación</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
            <b-row class="my-1">
              <b-col sm="2">
                <label>Año</label>
              </b-col>
              <b-col sm="2">
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.anno"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
              <b-col sm="2">
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.IdNacionAse"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.NombreAseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>
            
            <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Ejecutivos/Asistentes</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valEjecutivos"
                      v-model="datosFormulario.ejecutivo">
                  </b-form-select>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.ejecutivo }}</span>
              </b-col>
            </b-row>
         
            <b-row class="my-1">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group @change="consulta_corredor()">
                    <b-form-input type="number" v-model="datosFormulario.codCorredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button @click="buscarcorredor" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Producto</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valProductos"
                      v-model="datosFormulario.producto">
                  </b-form-select>
              </b-col>
            </b-row>

            <b-row class="mb-2">
              <b-col sm="2">
                <label>Incluir</label>
              </b-col>
              
              <b-col sm="5">
                <b-form-checkbox-group
                  v-model="selectedMon"
                  :options="ckdMoneda"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-checkbox-group>
              </b-col>             
            </b-row>
  
          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insercion" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Condiciones de Renovación</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <!-- <b-button v-if="hasPoliza" variant="primary" @click="nuevoContacto">Agregar Contacto</b-button> -->
            </b-col>  
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <table class="table-striped table-bordered table-hover" id="Glosa">
            <tbody>
              <tr role="row" class="odd">
                <td rowspan="3" class="text" style="min-width:100px"><p>Glosa *</p></td>
              </tr>
              <tr role="row" class="odd">
                <td colspan="2" style="min-width:200px" class="text">Renovación anticipada*</td>
                <td class="text" style="min-width:200px">Póliza no vence el año en curso</td>
              </tr>
            </tbody>
          </table>

          <br>
          <b-row>
            <b-col lg="12">             
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                >
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('FE')" 
                  prop="fecha_envio_propuesta"
                  label= "Fecha Envío de Propuesta"
                  align="center"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('FE')" 
                  prop="fecha_recepcion_ok_emitir"
                  label= "Fecha Recepción Ok para Emitir"
                  align="center"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('MP')"
                  prop="mabasemonpol"
                  label="MA Ren. Ant. Mon. Póliza"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('UF')"
                  prop="mabasemonreaj"
                  label="MA Ren. Ant. UF"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('US')"
                  prop="mabasemonreaj"
                  label="MA Ren. Ant. US"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>
                
                <el-table-column          
                  prop="tasal1base"
                  label="Tasa LN1"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column          
                  prop="tasal2base"
                  label="Tasa LN2"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column          
                  prop="tasal3base"
                  label="Tasa LN3"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column          
                  prop="tasal4base"
                  label="Tasa LN4"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('MP')"
                  prop="primabasemonpol"
                  label="Prima Tot. Ren. Ant. Mon. Póliza"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('UF')"
                  prop="primabasemonreaj"
                  label="Prima Tot. Ren. Ant. UF"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('US')"
                  prop="primabasemonreaj"
                  label="Prima Tot. Ren. Ant. US"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('MP')"
                  prop="marenmonpol"
                  label="MA Ren. Mon. Póliza"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('UF')"
                  prop="marenmonreaj"
                  label="MA Renovación UF"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('US')"
                  prop="marenmonreaj"
                  label="MA Renovación US"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="200"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="tasal1ren"
                  label="Tasa LN1 Renovación"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="tasal2ren"
                  label="Tasa LN2 Renovación"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="tasal3ren"
                  label="Tasa LN3 Renovación"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                  name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="tasal4ren"
                  label="Tasa LN4 Renovación"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('MP')"
                  prop="primarenmonpol"
                  label="Prima Tot. Ren. Mon. Póliza"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('UF')"
                  prop="primarenmonreaj"
                  label="Prima Tot. Ren. UF"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  v-if="selectedMon.includes('US')"
                  prop="primarenmonreaj"
                  label="Prima Tot. Ren. US"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="pctvarma"
                  label="Variación MA"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="pctvartasal1"
                  label="Variación Tasa"
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="pctvarprima"
                  label="Variación Prima Tot."
                  align="right"
                  sortable="custom"
                  :formatter="formatter"
                  width="150"
                   name="table"
                  class="table-responsive">
                </el-table-column>
                
                <el-table-column
                  prop="des_estadocomercial"
                  label="Estado Comercial"
                  align="center"
                  sortable="custom"
                  :formatter="formatter"
                  width="150"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column
                  prop="comentarios"
                  label="Comentarios"
                  align="left"
                  sortable="custom"
                  :formatter="formatter"
                  width="120"
                   name="table"
                  class="table-responsive">
                </el-table-column>

                <el-table-column label="" min-width="200px" align="center">
                <template slot-scope="scope">
                    <el-button
                          size="mini"
                          type="primary"
                          @click="button.handler"
                          v-for="button in customButtonsForRow(scope.row)"
                          :key="button.id"
                        >
                          {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

  <b-modal
      title="Modificación"
      scrollable
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      size="lg"
      v-model="modalModificar"
      @ok="actualiza_CondRenv();"
      @cancel="modalModificar = false"
    >   
      <b-row class="my-1">
        <b-col sm="4">
          <label>Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.poliza">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-1">
        <b-col sm="4">
          <label>Contratante</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcontratante">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Corredor</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.nomcorredor">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Producto</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.producto">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Ejecutivo</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.ejecutivo">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Asistente</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.asistente">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Estado Comercial</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-select
                :options="valEstados"
                v-model="datosFormularioModal.codestadocomercial">
              </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Moneda Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-input 
                  type="text" 
                  disabled
                  v-model="datosFormularioModal.monedapol">
              </b-form-input> 
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>MA Ren. Mon. Póliza</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <div v-b-tooltip.hover="!puedeEditarCampos ? 'Solo editable si el estado comercial es: Cambio N° de Póliza' : ''">
              <b-form-input 
                  type="text" 
                  :disabled="!puedeEditarCampos"
                  v-model="datosFormularioModal.mtoaserenmonpol"
              >
              </b-form-input> 
            </div>  
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Tasa L1 Renovación %</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
            <div v-b-tooltip.hover="!puedeEditarCampos ? 'Solo editable si el estado comercial es: Cambio N° de Póliza' : ''">
              <b-form-input 
                  type="text" 
                  :disabled="!puedeEditarCampos"
                  v-model="datosFormularioModal.tasalin1ren"
              >
              </b-form-input> 
            </div>  
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col sm="4">
          <label>Comentarios</label>
        </b-col>
        <b-col sm="8">
          <b-form-group>
              <b-form-textarea
                id="textarea"
                v-model="datosFormularioModal.comentarios"
                placeholder="Ingrese algún Comentario"
                rows="2"
                max-rows="6"
              ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    
    </b-modal>
    
    <b-modal
      size="lg"
      scrollable
      hide-footer
      title="Búsqueda de Contratante"
      cancel-title="Cancelar"
      v-model="modalContratante"
      @cancel="modalContratante = false"
    >
    <b-row class="my-1">
      <b-col sm="6">
        <label>Buscar:</label>
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroProceso"
            type="text"
            placeholder="Filtrar"
            v-model="filters2[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="data1"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters2"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titles2"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
                <template slot-scope="scope">
                    <div v-if="title.prop == 'pernombreimp'">  
                        <b-link type="text" v-if="scope.row.percodigo > 0" @click="selecciona_contratante(scope.row.percodigo, scope.row.pernombreimp, scope.row.peridnacion)" >{{scope.row.pernombreimp}}</b-link>
                        <p v-else >{{scope.row.pernombreimp}}</p>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>
              
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      title="Búsqueda de Corredor"
      scrollable
      cancel-title="Cerrar"
      class="modal-success"
      size="lg"
      v-model="modalCorredor"
      @cancel="modalCorredor = false"
      hide-footer
    >
      <b-row> 
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters3[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
      <b-row>
      <b-col lg="12">             
        <div ref="refTable">
          <data-tables ref="refTable1"
            :data="data2"
            name="table"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters3"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table"
            >
          <el-table-column
            v-for="title in titles3"
            :min-width="title.minwidth" 
            :prop="title.prop"
            :label='title.label'
            :key="title.label"
            :align="title.align"
            sortable="custom"
            :formatter="formatter"
            name="table"
            class="table-responsive"
            >
            <template slot-scope="scope">  
              <div v-if="title.prop == 'corredor'">    
                <b-link type="text" v-if="scope.row.codcorredor > 1" @click="selecciona_corredor(scope.row.codcorredor,scope.row.corredor,scope.row.idnacion)">{{scope.row.corredor}}</b-link>
                  <p v-else >{{scope.row.corredor}}</p>
                  </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
            </template>  

          </el-table-column>
          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>  

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiBaseDatosResoluc from "@/components/services/apiBaseDatosResoluc";
import apiCondRenovacion from "@/components/services/apiCondRenovacion";
import apiConCorredor  from "@/components/services/apiConCorredor";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "condicionesrenovacion",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      modalModificar : false,
      modalEliminar : false,
      modalContratante : false,
      modalCorredor : false,        
      modalNuevo : false,
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      selectedCor: [],
      selectedDire:[],
      selectedMon:[],
      data: [],
      data1: [],
      data2: [],
      nombreexcel: "CondicionesRenovacion",
      
      titles: [
        {
          prop: "corre",
          label: "N°",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "contratante",
          label: "Contratante",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "ejecutivo",
          label: "ECC",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "ejec_renovo",
          label: "ECC Renovación",
          align: "center",
          minwidth:'130'
        },
        {
          prop: "asistente",
          label: "EAC",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "fecha_ev_desde",
          label: "Vigencia Desde",
          align: "center",
          minwidth:'130'
        },
        {
          prop: "fecha_ev_hasta",
          label: "Vigencia Hasta",
          align: "center",
          minwidth:'130'
        },
        {
          prop: "annos",
          label: "Años",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "des_estadosistema",
          label: "Estado Sistema",
          align: "center",
          minwidth:'90'
        },
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "monpoliza",
          label: "Moneda Póliza",
          align: "left",
          minwidth:'120'
        }
      ],

      titles2: [
        {
          prop: "pernombreimp",
          label: "Contratante",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "percodigo",
          label: "Código",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "peridnacion",
          label: "Id Nacional",
          align: "center",
          minwidth:'100'
        },
      ],

      titles3: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "codcorredor",
          label: "Código",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "idnacion",
          label: "Id. Nacional",
          align: "center",
          minwidth:'120'
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filters2: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      filters3: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      datosFormularioModal: {
          poliza:"",
          nomcontratante:"",
          nomcorredor:"",
          producto:"",
          ejecutivo:"",
          asistente:"",
          ejecrenovo:"",
          feenvpropuesta:"",
          ferecepcokemitir:"",
          codestadocomercial:"",
          monedapol:"",
          mtoaserenmonpol:"",
          tasalin1ren:"",
          comentarios:"",
      },
      
      mostrarFechas: true,
      datosFormulario: {
          anno: "",
          poliza:"",
          producto:"",
          contratante:"",
          IdNacionAse :"",
          NombreAseg:"",
          IdNacionCorred:"",
          NombreCorred:"",
          ejecutivopol:"",
          ejecutivo:"",
          asistentepol:"",
          annoactual: 0,
          valor_monereaj: 0,
          valor_pesocol: 0,
          valor_eu: 0,
          valor_us: 0
          
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      valEjecutivos: [],
      valEstados: [],
      valProductos: [],
      productos: [],
      ckdMoneda:[],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
          obj.tooltip = "Modificar";
          obj.id = 1;
          obj.name="Modificar";
          obj.icon = "fa fa-pencil-square-o";
          obj.type = "success";
          obj.handler= _ => {
              this.$session.start();
              this.modificar(row);
          }
          botones.push(obj);
          
          return botones;
    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    limpiarNumero(valor) {
      if (!valor) return null
    
      valor = valor.toString().trim()
    
      // Detectar cuál es el separador decimal
      const tieneComa = valor.includes(',')
      const tienePunto = valor.includes('.')
    
      let decimalSeparator = '.'
    
      if (tieneComa && tienePunto) {
        // El último símbolo suele ser el decimal
        decimalSeparator = valor.lastIndexOf(',') > valor.lastIndexOf('.')
          ? ','
          : '.'
      } else if (tieneComa) {
        decimalSeparator = ','
      }
    
      // Si el decimal es coma (Chile)
      if (decimalSeparator === ',') {
        valor = valor.replace(/\./g, '')   // quitar miles
        valor = valor.replace(',', '.')    // cambiar decimal a punto
      } 
      // Si el decimal es punto (Perú)
      else {
        valor = valor.replace(/,/g, '')    // quitar miles
      }
    
      // Eliminar cualquier carácter extraño
      valor = valor.replace(/[^0-9.]/g, '')
    
      // Evitar más de un punto decimal
      const partes = valor.split('.')
      if (partes.length > 2) {
        valor = partes[0] + '.' + partes.slice(1).join('')
      }
    
      return Number(valor)
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    selecciona_contratante(p_codcontratante, p_nomcontratante, p_idnacional){
      this.datosFormulario.contratante = p_codcontratante;
      this.datosFormulario.IdNacionAse = p_idnacional;
      this.datosFormulario.NombreAseg = p_nomcontratante
      this.modalContratante = false;
    },

    selecciona_corredor(p_codcorredor, p_corredor, p_idnacion) {
       this.datosFormulario.codCorredor = p_codcorredor;
       this.datosFormulario.NombreCorred = p_corredor;
       this.datosFormulario.IdNacionCorred = p_idnacion;
       this.modalCorredor = false;   
    },
    
    pre_insercion() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.anno = "";
      this.datosFormulario.ejecutivo = '0';
      this.datosFormulario.poliza = "";
      this.datosFormulario.producto = "";
      this.datosFormulario.codCorredor = "";
      this.datosFormulario.NombreCorred = "";
      this.datosFormulario.IdNacionCorred = "";
      this.datosFormulario.NombreAseg = "";
      this.datosFormulario.IdNacionAse = "";
      this.hasPoliza = false;

      return apiCondRenovacion
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo ='0';
          this.datosFormulario.poliza='';
          this.datosFormulario.contratante='';
          this.datosFormulario.codCorredor='';

          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array(); 
          var objTodos = new Object();
          objTodos.value = "0";
          objTodos.text  = "Todos";
          tiposEjecutivos.push(objTodos); 

          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["usucodigo"];
              obj.text = lista_tipos_ejecutivos[i]["usunombre"];
              tiposEjecutivos.push(obj);
          }

          this.valEjecutivos = tiposEjecutivos;
          
          //carga de listados
          this.valProductos = this.llenaArrayLista(response.data.productos, 'codigo', 'descripcion', false);
          this.valEstados = this.llenaArrayLista(response.data.estados, 'codigo', 'descripcion', false);

          this.datosFormulario.anno = response.data.args_out.anno; 

          console.log(process.env.VUE_APP_LOCALE);
        
        if (process.env.VUE_APP_LOCALE === 'es-cl'){
          this.ckdMoneda =  [
           { item:  'MP', name: 'Incluir monto en Moneda Póliza'},
           { item:  'UF', name: 'Incluir monto en UF' }
          ]
        } else if(process.env.VUE_APP_LOCALE === 'es-pe'){
          this.ckdMoneda =  [
          { item:  'MP', name: 'Incluir monto en Moneda Póliza'},  
          { item:  'US', name: 'Incluir monto en US' }
          ]
        } else if(process.env.VUE_APP_LOCALE === 'es-ar'){
          this.ckdMoneda =  [
          { item:  'MP', name: 'Incluir monto en Moneda Póliza'},   
          { item:  'US', name: 'Incluir monto en US' }
          ]
        }         
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      var p_email = this.$session.get("mail");
      var p_usuario = this.$session.get("usuarioInterno");

      this.datosFormulario.ejecutivo == 'Todos' ? '' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_ejecutivo= this.datosFormulario.ejecutivo == 'Todos' ? '0' : this.datosFormulario.ejecutivo; 
      var p_anno = this.datosFormulario.anno;
      var p_poliza = this.datosFormulario.poliza == ''? '0' : this.datosFormulario.poliza;
      var p_corredor = this.datosFormulario.codCorredor == ''? '0' : this.datosFormulario.codCorredor;
      var p_producto = this.datosFormulario.producto == ''? '0' : this.datosFormulario.producto;

      //console.log("ENTRÓ A CONSULTAR");

      return apiCondRenovacion
      .recuperar(p_email, p_usuario, p_ejecutivo, p_anno, p_poliza, p_corredor, p_producto
        ).then( (response)=>{
            console
            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;

            this.datosFormulario.annoactual = response.data.res2[0].anno;
            this.datosFormulario.valor_monereaj = response.data.res2[0].valor_monereaj;
            this.datosFormulario.valor_pesocol = response.data.res2[0].valor_pesocol;
            this.datosFormulario.valor_eu = response.data.res2[0].valor_eu;
            this.datosFormulario.valor_us = response.data.res2[0].valor_us;
 
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "fecha"
          ) && row[column.property]) {
           return this.configurarFechaLat(this.convierteFecha(row[column.property]));
           } 
      else if ((column.property == "mabasemonpol" || column.property == "mabasemonreaj" || 
                  column.property == "tasal1base" || column.property == "tasal2base" || column.property == "tasal3base" || column.property == "tasal4base" ||
                  column.property == "tasal1ren" || column.property == "tasal2ren" || column.property == "tasal3ren" || column.property == "tasal4ren" ||
                  column.property == "primabasemonpol" || column.property == "primabasemonreaj" || 
                  column.property == "marenmonpol" || column.property == "marenmonreaj" || 
                  column.property == "primarenmonpol" || column.property == "primarenmonreaj" ||
                  column.property == "pctvarma" || column.property == "pctvartasal1" || column.property == "pctvarprima"
                  ) && row[column.property]) 
                  {
                    if (row[column.property] == -1 || row[column.property] == "-1"){
                      return "N/A";
                      }
                    if (row[column.property] == 0 || row[column.property] == "0") {
                      return row[column.property];
                      } 
                  else {
                      if (column.property == "tasal1base" || column.property == "tasal2base" || column.property == "tasal3base" || column.property == "tasal4base" ||
                          column.property == "tasal1ren" || column.property == "tasal2ren" || column.property == "tasal3ren" || column.property == "tasal4ren" 
                          )
                          {return this.$numeral(row[column.property]).format("0,0.000") +"%" }
                      else {
                          if (column.property == "pctvarma" || column.property == "pctvartasal1" || column.property == "pctvarprima"
                              )
                              {return this.$numeral(row[column.property]).format("0,0.00") +"%" }
                          else  
                              {return this.$numeral(row[column.property]).format("0,0.00")}
                            }
                        }
                   } 
          else {
                return row[column.property];
               }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xlPercent1 =
        "padding:0px; font-size:11pt; font-family:Calibri; "+"mso-number-format:\"0.000%\"; text-align:right; border:.5pt solid windowtext;";
      var xlPercent2 =
        "padding:0px; font-size:11pt; font-family:Calibri; "+"mso-number-format:\"0.00%\"; text-align:right; border:.5pt solid windowtext;";  
      // TÍTULO
      cuerpo += "<style='border-collapse:collapse;table-layout:fixed;width:550pt;border:1px solid black;'>";
      cuerpo += "<tr>";

      cuerpo += "<td style='" + xl649618 + "font-weight:bold;text-align:center;' colspan='2'>Tipo de Cambio 01/01/" + this.datosFormulario.annoactual + "</td>";
      cuerpo += "</tr>";

      // UF
      cuerpo += "<tr>";
      cuerpo += "<td style='" + xl649618 + "'>UF</td>";
      cuerpo += "<td style='" + xl649618 + "text-align:right; mso-number-format:\"\\@\";'>" + this.$numeral(this.datosFormulario.valor_monereaj).format("0,0.00") + "</td>";
      cuerpo += "</tr>";  

      // US
      cuerpo += "<tr>";
      cuerpo += "<td style='" + xl649618 + "'>US</td>";
      cuerpo += "<td style='" + xl649618 + "text-align:right; mso-number-format:\"\\@\";'>" + this.$numeral(this.datosFormulario.valor_us).format("0,0.00") + "</td>";
      cuerpo += "</tr>";

      // EU
      cuerpo += "<tr>";
      cuerpo += "<td style='" + xl649618 + "'>EU</td>";
      cuerpo += "<td style='" + xl649618 + "text-align:right; mso-number-format:\"\\@\";'>" + this.$numeral(this.datosFormulario.valor_eu).format("0,0.00") + "</td>";
      cuerpo += "</tr>";

      // CO
      cuerpo += "<tr>";
      cuerpo += "<td style='" + xl649618 + "'>CO</td>";
      cuerpo += "<td style='" + xl649618 + "text-align:right; mso-number-format:\"\\@\";'>" + this.$numeral(this.datosFormulario.valor_pesocol).format("0,0.00") + "</td>";
      cuerpo += "</tr>";

      // === FILA SEPARADORA ===
     cuerpo += "<tr><td colspan='40' style='border:none;height:15pt;'></td></tr>";

      ///COLUMNAS ESCRIBIR
      cuerpo += "<table border='1' cellpadding='0' cellspacing='0' width='730' " + "style='border-collapse:collapse;table-layout:fixed;width:550pt;border:1px solid black;'>";
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "N°" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Póliza" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Contratante" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Producto" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "ECC" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "ECC Renovación" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "EAC" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Vigencia Desde" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Vigencia Hasta" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Años" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Estado Sistema" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Corredor" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Moneda Póliza" + "</td>\n";
        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "MA Ren. Ant. Mon. Póliza" + "</td>\n";
        } 
        if (this.selectedMon.includes('UF')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "MA Ren. Ant. UF" + "</td>\n";
        } 
        if (this.selectedMon.includes('US')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "MA Ren. Ant. US" + "</td>\n";
        }       
        
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN1 %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN2 %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN3 %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN4 %" + "</td>\n";
        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Prima Tot. Ren. Ant. Mon. Póliza" + "</td>\n";
        }    
        if (this.selectedMon.includes('UF')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Prima Tot. Ren. Ant. UF" + "</td>\n";
        }  
        if (this.selectedMon.includes('US')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Prima Tot. Ren. Ant. US" + "</td>\n";
        } 
        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "MA Ren. Mon. Póliza" + "</td>\n";
        }    
        if (this.selectedMon.includes('UF')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "MA Renovación UF" + "</td>\n";
        }     
        if (this.selectedMon.includes('US')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "MA Renovación US" + "</td>\n";
        }  
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN1 Renovación %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN2 Renovación %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN3 Renovación %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Tasa LN4 Renovación %" + "</td>\n";
        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Prima Tot. Ren. Mon. Póliza" + "</td>\n";
        }  
        if (this.selectedMon.includes('UF')){  
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Prima Tot. Ren. UF" + "</td>\n";
        }   
        if (this.selectedMon.includes('US')){  
            cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Prima Tot. Ren. US" + "</td>\n";
        }  
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Variación MA %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Variación Tasa %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Variación Prima Tot. %" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Estado Comercial" + "</td>\n";
      cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "font-weight:bold;'>" + "Comentarios" + "</td>\n";

      cuerpo += "</tr>\n";
      
      //Data bloque 1
      
      for (var key in this.data) {
        if(this.data[key]["poliza"] === undefined){ 
          this.data[key]["poliza"] = "";
        }
        if(this.data[key]["contratante"] === undefined){ 
          this.data[key]["contratante"] = "";
        }
        if(this.data[key]["producto"] == undefined){ 
          this.data[key]["producto"] = "";
        }
        if(this.data[key]["ejecutivo"] == undefined){ 
          this.data[key]["ejecutivo"] = "";
        }
        if(this.data[key]["ejec_renovo"] == undefined){ 
          this.data[key]["ejec_renovo"] = "";
        }
        if(this.data[key]["asistente"] == undefined){ 
          this.data[key]["asistente"] = "";
        }
        if(this.data[key]["fecha_ev_desde"] == undefined){ 
          this.data[key]["fecha_ev_desde"] = "";
        }
        if(this.data[key]["fecha_ev_hasta"] == undefined){ 
          this.data[key]["fecha_ev_hasta"] = "";
        }
        if(this.data[key]["annos"] == undefined){ 
          this.data[key]["annos"] = "";
        }
        if(this.data[key]["des_estadosistema"] == undefined){ 
          this.data[key]["des_estadosistema"] = "";
        }
        if(this.data[key]["corredor"] == undefined){ 
          this.data[key]["corredor"] = "";
        }
        if(this.data[key]["monpoliza"] == undefined){ 
          this.data[key]["monpoliza"] = "";
        }
        if(this.data[key]["mabasemonpol"] == undefined){ 
          this.data[key]["mabasemonpol"] = "";
        }
        if(this.data[key]["mabasemonreaj"] == undefined){ 
          this.data[key]["mabasemonreaj"] = "";
        }
        if(this.data[key]["tasal1base"] == undefined){ 
          this.data[key]["tasal1base"] = "";
        }
        if(this.data[key]["tasal2base"] == undefined){ 
          this.data[key]["tasal2base"] = "";
        }
        if(this.data[key]["tasal3base"] == undefined){ 
          this.data[key]["tasal3base"] = "";
        }
        if(this.data[key]["tasal4base"] == undefined){ 
          this.data[key]["tasal4base"] = "";
        }
        if(this.data[key]["primabasemonpol"] == undefined){ 
          this.data[key]["primabasemonpol"] = "";
        }
        if(this.data[key]["primabasemonreaj"] == undefined){ 
          this.data[key]["primabasemonreaj"] = "";
        }
        if(this.data[key]["marenmonpol"] == undefined){ 
          this.data[key]["marenmonpol"] = "";
        }
        if(this.data[key]["marenmonreaj"] == undefined){ 
          this.data[key]["marenmonreaj"] = "";
        }
        if(this.data[key]["tasal1ren"] == undefined){ 
          this.data[key]["tasal1ren"] = "";
        }
        if(this.data[key]["tasal2ren"] == undefined){ 
          this.data[key]["tasal2ren"] = "";
        }
        if(this.data[key]["tasal3ren"] == undefined){ 
          this.data[key]["tasal3ren"] = "";
        }
        if(this.data[key]["tasal4ren"] == undefined){ 
          this.data[key]["tasal4ren"] = "";
        }
        if(this.data[key]["primarenmonpol"] == undefined){ 
          this.data[key]["primarenmonpol"] = "";
        }
        if(this.data[key]["primarenmonreaj"] == undefined){ 
          this.data[key]["primarenmonreaj"] = "";
        }
        if(this.data[key]["pctvarma"] == undefined){ 
          this.data[key]["pctvarma"] = "";
        }
        if(this.data[key]["pctvartasal1"] == undefined){ 
          this.data[key]["pctvartasal1"] = "";
        }
        if(this.data[key]["pctvarprima"] == undefined){ 
          this.data[key]["pctvarprima"] = "";
        }
        if(this.data[key]["des_estadocomercial"] == undefined){ 
          this.data[key]["des_estadocomercial"] = "";
        }
        if(this.data[key]["comentarios"] == undefined){ 
          this.data[key]["comentarios"] = "";
        }
        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corre"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["contratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejec_renovo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asistente"] + "</td>\n";
        cuerpo += "<td style='" + xl649618 + "border-style:solid; border-width:thin; mso-number-format:\"\\@\";'>" + this.data[key]["fecha_ev_desde"] + "</td>\n";
        cuerpo += "<td style='" + xl649618 + "border-style:solid; border-width:thin; mso-number-format:\"\\@\";'>" + this.data[key]["fecha_ev_hasta"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["annos"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["des_estadosistema"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["monpoliza"] + "</td>\n";

        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mabasemonpol"]).format("0,0.00") + "</td>\n";
        }
        if (this.selectedMon.includes('UF')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mabasemonreaj"]).format("0,0.00") + "</td>\n";
        }     
        if (this.selectedMon.includes('US')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mabasemonreaj"]).format("0,0.00") + "</td>\n";
        }             

        cuerpo += this.tdPercent(this.data[key]["tasal1base"], xlPercent1) + "\n";
        cuerpo += this.tdPercent(this.data[key]["tasal2base"], xlPercent1) + "\n";
        cuerpo += this.tdPercent(this.data[key]["tasal3base"], xlPercent1) + "\n";
        cuerpo += this.tdPercent(this.data[key]["tasal4base"], xlPercent1) + "\n";

        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primabasemonpol"]).format("0,0.00") + "</td>\n";
        }    
        if (this.selectedMon.includes('UF')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primabasemonreaj"]).format("0,0.00") + "</td>\n";
        }   
        if (this.selectedMon.includes('US')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primabasemonreaj"]).format("0,0.00") + "</td>\n";
        }   

        if (this.selectedMon.includes('MP')){
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["marenmonpol"]).format("0,0.00") + "</td>\n";
        }
        if (this.selectedMon.includes('UF')){
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["marenmonreaj"]).format("0,0.00") + "</td>\n";
        }
        if (this.selectedMon.includes('US')){
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["marenmonreaj"]).format("0,0.00") + "</td>\n";
        }

        cuerpo += this.tdPercent(this.data[key]["tasal1ren"], xlPercent1) + "\n";
        cuerpo += this.tdPercent(this.data[key]["tasal2ren"], xlPercent1) + "\n";
        cuerpo += this.tdPercent(this.data[key]["tasal3ren"], xlPercent1) + "\n";
        cuerpo += this.tdPercent(this.data[key]["tasal4ren"], xlPercent1) + "\n";

        if (this.selectedMon.includes('MP')){
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primarenmonpol"]).format("0,0.00") + "</td>\n";
        }
        if (this.selectedMon.includes('UF')){
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primarenmonreaj"]).format("0,0.00") + "</td>\n";
        }
        if (this.selectedMon.includes('US')){
           cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["primarenmonreaj"]).format("0,0.00") + "</td>\n";
        }

        cuerpo += this.tdPercent(this.data[key]["pctvarma"], xlPercent2) + "\n";
        cuerpo += this.tdPercent(this.data[key]["pctvartasal1"], xlPercent2) + "\n";
        cuerpo += this.tdPercent(this.data[key]["pctvarprima"], xlPercent2) + "\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["des_estadocomercial"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["comentarios"] + "</td>\n";
        cuerpo += "</tr>\n";

      }
      cuerpo += "</table>";


      //Data bloque 1
      
      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

   tdPercent: function(valor, estilo) {
    if (valor === null || valor === undefined || valor === "") return "<td></td>";
    
    let v = parseFloat(valor);
    if (isNaN(v)) return "<td></td>";

    return "<td style='" + estilo + "' x:num='" + v/100 + "'>" + v + "</td>";
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function') 
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    consulta_poliza: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;
      
      this.datosFormulario.ejecutivo == 'Todos' ? '0' : this.datosFormulario.ejecutivo; 
      this.datosFormulario.poliza == ''? '' : this.datosFormulario.poliza;
      this.datosFormulario.codCorredor == '' ? '': this.datosFormulario.codCorredor;

      var p_email= this.$session.get("mail");
      var p_ejecutivo= this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo==""){
          p_ejecutivo ='0';
      }

      return apiBaseDatosResoluc
        .consulta_poliza(
          p_email, p_ejecutivo, p_poliza
        ).then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //console.log(response.data.res);

          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza       = Listapoliza[i]["marpoliza"];
            this.datosFormulario.contratante  = Listapoliza[i]["marcontratante"];
            this.datosFormulario.producto     = Listapoliza[i]["marproducto"];
            this.datosFormulario.codCorredor  = Listapoliza[i]["marcorredor"];
            this.datosFormulario.NombreCorred = Listapoliza[i]["nomcorredor"];
            this.datosFormulario.vigente      = Listapoliza[i]["E"];
            this.datosFormulario.ejecutivopol = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.asistentepol   = Listapoliza[i]["asistente"]; 
            this.hasPoliza = true;
          }
          this.$Progress.finish();
          this.consulta_contratante();
          this.consulta_corredor();  

          // this.buscar();  
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_contratante: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_contratante = this.datosFormulario.contratante == '' ? '0': this.datosFormulario.contratante; 
      var p_email = this.$session.get("mail");
      if ((p_contratante==0) || (p_contratante=="")){
          this.mensaje= "Ingrese SR Contratante";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, p_contratante
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         var InfoContratante = response.data.res;

         for (var i = 0; i < InfoContratante.length; i++) {
            this.datosFormulario.IdNacionAse = InfoContratante[i]["peridnacion"];
            this.datosFormulario.NombreAseg  = InfoContratante[i]["pernombreimp"];
            
            this.datosFormulario.asegperdireccion  = InfoContratante[i]["perdireccion"];
            this.datosFormulario.asegperciudad  = InfoContratante[i]["perciudad"];
            this.datosFormulario.asegpercomuna  = InfoContratante[i]["percomuna"];
            this.datosFormulario.asegpernacion  = InfoContratante[i]["pernacion"];
            this.datosFormulario.asegperdirpostal  = InfoContratante[i]["perdirpostal"];
            this.datosFormulario.asegperciupostal  = InfoContratante[i]["perciupostal"];
            this.datosFormulario.asegpercompostal  = InfoContratante[i]["percompostal"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      
      if ((p_corredor==0) || (p_corredor=="")){
          this.datosFormulario.IdNacionCorred = "";
          this.datosFormulario.NombreCorred ="";
          this.mensaje= "Ingrese SR Corredor.";
          this.variant="warning";
          this.showAlert();
           return false;
      }
      return apiBaseDatosResoluc
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         response.data = this.keysMinuscula(response.data);
         console.log(response.data);
         var InfoCorredor = response.data.res;
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["idnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["corredor"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    DatosContratantes: function(){
      
      var p_email = this.$session.get("mail");
      
      return apiBaseDatosResoluc
        .consulta_contratante(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data1 = response.data.res;
            this.$Progress.finish();
         
          this.$Progress.finish();
          this.modalContratante = true;
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },

    buscarcorredor() {
      this.$Progress.start();
      var p_email= this.$session.get("mail");

      return apiConCorredor
        .consulta_corredor(
          p_email, 0
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data2 = response.data.res;
            this.modalCorredor = true;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },
    
    modificar: function( row ){
  //    console.log(row);
      this.datosFormularioModal.poliza = row.poliza;
      this.datosFormularioModal.nomcontratante = row.contratante;
      this.datosFormularioModal.nomcorredor = row.corredor;
      this.datosFormularioModal.producto = row.producto;
      this.datosFormularioModal.ejecutivo = row.ejecutivo;
      this.datosFormularioModal.asistente = row.asistente;
      this.datosFormularioModal.ejecrenovo = row.ejec_renovo;
      this.datosFormularioModal.feenvpropuesta = row.fecha_envio_propuesta_date;
      this.datosFormularioModal.ferecepcokemitir = row.fecha_recepcion_ok_emitir_date;
      this.datosFormularioModal.monedapol = row.monpoliza;
      this.datosFormularioModal.mtoaserenmonpol =  this.$numeral(row.marenmonpol).format("0,0.00");
      this.datosFormularioModal.tasalin1ren = this.$numeral(row.tasal1ren).format("0,0.000");
      this.datosFormularioModal.codestadocomercial = row.codestadocomercial;
      this.datosFormularioModal.comentarios = row.comentarios;
      this.modalModificar = true;
    },

    actualiza_CondRenv() {
      let rows = this.datosFormularioModal;
        //Modificar
        return apiCondRenovacion
          .fnc_actualiza(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormularioModal.ejecrenovo,
            this.datosFormulario.anno,
            this.datosFormularioModal.poliza,
            this.datosFormularioModal.codestadocomercial,
            this.datosFormularioModal.comentarios,
            this.datosFormularioModal.feenvpropuesta, 
            this.datosFormularioModal.ferecepcokemitir,
            this.limpiarNumero(this.datosFormularioModal.mtoaserenmonpol),
            this.limpiarNumero(this.datosFormularioModal.tasalin1ren)
          )
          .then((response) => {
            
            response.data = this.keysMinuscula(response.data);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Editar",
                "Se ha actualiza exitosamente.",
                "success"
              );
            }
            else{
              this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
            }
            this.buscar();
          })
          .catch((error) => {
            this.mensaje= error;
            this.variant="danger";
            this.showAlert();
          });            
    }, 
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insercion();    
    //this.buscar();
  },

  computed:{
        puedeEditarCampos() { 
            return this.datosFormularioModal.codestadocomercial === "CNP";
        }
    },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
